
import axios from 'axios';
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api') + '/auth';

export async function changePassword({ oldPassword, newPassword }) {
  return axios.post(`${API_BASE_URL}/change-password`, { oldPassword, newPassword });
}

// In your auth.js file
export const resendVerificationEmail = async ({ email }) => {
  const response = await axios.post(`${API_BASE_URL}/resend-verification`, { email });
  return response;
};

export async function register({ email, username, password }) {
  return axios.post(`${API_BASE_URL}/register`, { email, username, password });
}

export async function login({ email, password, rememberMe }) {
  return axios.post(`${API_BASE_URL}/login`, { email, password, rememberMe });
}

export async function logout() {
  return axios.post(`${API_BASE_URL}/logout`);
}

export function setAuthToken(token) {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
}
